import jsonp from 'jsonp';

import shareCountFactory from './utils/shareCountFactory';

function getFacebookShareCount(shareUrl, callback) {
  var endpoint = 'https://graph.facebook.com/?id=' + shareUrl;

  jsonp(endpoint, function (err, data) {
    callback(!err && data && data.share && data.share.share_count ? data.share.share_count : undefined);
  });
}

export default shareCountFactory(getFacebookShareCount);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/FacebookShareCount.js
// module id = 1662
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 20 21